import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CheckoutFooter from "../components/footer";
import AppConfig from "../../appConfig";
import axios from "../../axios";
import usePageTitle from "../pageTitle";
import {
  // Container,
  Box,
  Backdrop,
  Alert,
  Snackbar,
  CircularProgress,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Icon,
  Divider,
  Dialog,
  DialogContent,
  // DialogContentText,
  // DialogTitle,
  DialogActions,
  Button,
  Checkbox,
} from "@mui/material";
import { CheckBox } from "@mui/icons-material";

function SmmShare() {
  usePageTitle("Get Paid Instantly");

  const { ref } = useParams();
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [inviter, setInviter] = useState(null);
  const [campaign, setCampaign] = useState(null);
  const [platforms, setPlatforms] = useState([]);
  const [authUrl, setAuthUrl] = useState(null);
  const [selectedPlatform, setSelectedPlatform] = useState("");
  // const [criteria, setCriteria] = useState(null);
  const [tosAgree, setTosAgree] = useState(false);
  const [openAuthDialog, setOpenAuthDialog] = useState(false);

  useEffect(() => {
    if (ref === null) {
      navigate("/error");
      return;
    }

    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`sm/share/${ref}/fetch.json`)
        .then((result) => {
          console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setInviter(result.data.data.inviter);
            setCampaign(result.data.data.content);
            setPlatforms(result.data.data.platforms);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg("An error occurred.");
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  async function getAuthUrl(plat4m) {
    setShowLoading(true);
    const json = {
      reference: ref,
      platform: plat4m,
    };

    console.log(json);

    await axios
      .post("sm/share/authUrl.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          // window.location.href = result.data.data.authUrl;
          // window.open(result.data.data.authUrl, '_blank');
          setAuthUrl(result.data.data.authUrl);
          // setCriteria(result.data.data.criteria);
          setOpenAuthDialog(true);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg("An error occurred.");
        setOpen(true);
      });
  }

  return (
    <>
      <Box mb={5}>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={showLoading}
          onClick={handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleClose}
            severity={severity}
            sx={{ width: "100%" }}
          >
            {errorMsg}
          </Alert>
        </Snackbar>
        <Dialog open={openAuthDialog} fullWidth maxWidth="xs">
          <DialogContent>
            <Box align="center">
              <Icon color="warning" sx={{ size: 48 }}>
                info
              </Icon>
            </Box>
            {selectedPlatform.toUpperCase() === "TIKTOK" ? (
              <Box mt={1}>
                <Typography align="center">
                  Important data privacy points to note before proceeding. If
                  you consent, please click the Agree Button to proceed.
                </Typography>
                <List mt={1}>
                  <ListItem>
                    <ListItemIcon>
                      <CheckBox color="primary" />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography
                          variant="subtitle2"
                          fontSize={11}
                          fontWeight={400}
                        >
                          You have previewed the media content and caption
                          properly.
                        </Typography>
                      }
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <CheckBox color="primary" />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography
                          variant="subtitle2"
                          fontSize={11}
                          fontWeight={400}
                        >
                          This content will be posted under the{" "}
                          <b>PRIVACY STATUS: PUBLIC TO EVERYONE</b>.
                        </Typography>
                      }
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <CheckBox color="primary" />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography
                          variant="subtitle2"
                          fontSize={11}
                          fontWeight={400}
                        >
                          Other TikTok users will be <b>ALLOWED TO COMMENT</b>{" "}
                          on this content once posted.
                        </Typography>
                      }
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <CheckBox color="primary" />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography
                          variant="subtitle2"
                          fontSize={11}
                          fontWeight={400}
                        >
                          This content will be labeled as{" "}
                          <b>PAID PARTNERSHIP</b> once posted.
                        </Typography>
                      }
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <CheckBox color="primary" />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography
                          variant="subtitle2"
                          fontSize={11}
                          fontWeight={400}
                        >
                          This content will be visible to your <b>FRIENDS</b>{" "}
                          and the <b>PUBLIC</b> once posted.
                        </Typography>
                      }
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <CheckBox color="primary" />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography
                          variant="subtitle2"
                          fontSize={11}
                          fontWeight={400}
                        >
                          This content may take a few minutes to process and be
                          visible on your profile
                        </Typography>
                      }
                    />
                  </ListItem>
                </List>
                <Box display="flex" alignItems="center" ml={-1}>
                  <Checkbox
                    checked={tosAgree}
                    onChange={(e) => {
                      setTosAgree(e.target.checked);
                    }}
                  />
                  <Typography
                    variant="subtitle2"
                    fontSize={11}
                    fontWeight={400}
                  >
                    By posting, you agree to TikTok's{" "}
                    <a href="https://www.tiktok.com/legal/page/global/bc-policy/en">
                      <i>Branded Content Policy</i>
                    </a>{" "}
                    and{" "}
                    <a href="https://www.tiktok.com/legal/page/global/music-usage-confirmation/en">
                      <i>Music Usage Confirmation</i>
                    </a>
                    .
                  </Typography>
                </Box>
              </Box>
            ) : (
              <Box mt={3}>
                <Typography>Important data privacy points to note:</Typography>
                <List>
                  <ListItem>
                    <ListItemIcon>
                      <CheckBox color="primary" />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography
                          variant="subtitle2"
                          fontSize={11}
                          fontWeight={400}
                        >
                          For optimal performance, you are not allowed to delete
                          this post <b>before 24 hrs.</b>
                        </Typography>
                      }
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <CheckBox color="primary" />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography
                          variant="subtitle2"
                          fontSize={11}
                          fontWeight={400}
                        >
                          You have previewed the media content and caption
                          properly
                        </Typography>
                      }
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <CheckBox color="primary" />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography
                          variant="subtitle2"
                          fontSize={11}
                          fontWeight={400}
                        >
                          This post will be viewable to the public
                        </Typography>
                      }
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <CheckBox color="primary" />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography
                          variant="subtitle2"
                          fontSize={11}
                          fontWeight={400}
                        >
                          This post will allow comments from your network
                        </Typography>
                      }
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <CheckBox color="primary" />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography
                          variant="subtitle2"
                          fontSize={11}
                          fontWeight={400}
                        >
                          This post will be labelled as Paid Partnership
                        </Typography>
                      }
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <CheckBox color="primary" />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography
                          variant="subtitle2"
                          fontSize={11}
                          fontWeight={400}
                        >
                          This post may take a few minutes to process and be
                          visible on your profile
                        </Typography>
                      }
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Checkbox
                        checked={tosAgree}
                        onChange={(e) => {
                          setTosAgree(e.target.checked);
                        }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography
                          variant="subtitle2"
                          fontSize={11}
                          fontWeight={400}
                        >
                          By posting, you agree to the terms and conditions of{" "}
                          <b>{selectedPlatform}</b>
                        </Typography>
                      }
                    />
                  </ListItem>
                </List>
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setOpenAuthDialog(false);
              }}
              color="secondary"
              variant="outlined"
              iconOnly
              circular
            >
              <Icon>close</Icon>
            </Button>
            <Button
              onClick={() => {
                if (tosAgree === false) {
                  alert(
                    `Please agree to ${selectedPlatform}'s content and usage policies`
                  );
                  return;
                }
                setOpenAuthDialog(false);
                window.open(authUrl, "_blank").focus();
              }}
              color="primary"
              variant="outlined"
              iconOnly
              circular
            >
              <Icon>send</Icon>
            </Button>
          </DialogActions>
        </Dialog>
        {campaign !== null ? (
          <Box
            mt={10}
            sx={{ width: "100%", maxWidth: "480px", margin: "25px auto" }}
          >
            <Box align="center">
              {/* <Typography fontWeight={800}>
                Get paid to post on Social Media
              </Typography>
              <Typography fontWeight={800}>Share To TikTok</Typography> */}
            </Box>
            <Box mt={1}>
              <Paper>
                <Box p={2}>
                  {/* <Box align="center">
                    <Typography>
                      <b>{inviter}</b> is inviting you to get paid on Laddar.
                    </Typography>
                  </Box>
                  <Box mt={2} align="center">
                    <Typography fontSize={12}>
                      Simply post the advert below on any of your social
                      media accounts and earn money instantly.
                    </Typography>
                  </Box> */}
                  <Box mt={1} align="center">
                    {campaign.type === "VIDEO" ? (
                      <Box
                        sx={{
                          padding: "10px",
                          background: "#D3D3D3",
                          webkitBorderRadius: "15px",
                          borderRadius: "15px",
                          overflow: "hidden",
                        }}
                      >
                        <iframe
                          title={campaign.caption}
                          type="text/html"
                          width="100%"
                          height="480"
                          src={`${AppConfig.api_media_url}${campaign.media}`}
                          frameBorder="0"
                          allowFullScreen
                        />
                      </Box>
                    ) : (
                      <Paper elevation={0}>
                        <Box
                          p={2}
                          sx={{
                            padding: "10px",
                            background: "#D3D3D3",
                            webkitBorderRadius: "15px",
                            borderRadius: "15px",
                            overflow: "hidden",
                          }}
                        >
                          <img
                            src={`${AppConfig.api_media_url}${campaign.media}`}
                            alt={campaign.caption}
                            width="100%"
                            // width="320px"
                          />
                        </Box>
                      </Paper>
                    )}
                  </Box>
                  <Box mt={3}>
                    <Typography fontSize={12}>Caption</Typography>
                    <Typography mt={1}>{campaign.caption}</Typography>
                  </Box>
                  <Box mt={2}>
                    <Divider />
                  </Box>
                  <Box mt={2}>
                    <List disablePadding>
                      {platforms.map((platform) => (
                        <ListItem
                          key={platform.reference}
                          sx={{ py: 1, px: 0, mb: 1 }}
                          onClick={() => {
                            getAuthUrl(platform.reference);
                            setSelectedPlatform(platform.title);
                          }}
                        >
                          <ListItemIcon>
                            <img
                              src={`${AppConfig.api_media_url}${platform.logo}`}
                              alt={platform.title}
                              width="36px"
                            />
                          </ListItemIcon>
                          <ListItemText
                            sx={{ mr: 2 }}
                            primary={
                              <Typography
                                variant="subtitle2"
                                fontSize={11}
                                fontWeight={400}
                              >
                                {/* {platform.title}: {campaign.currency}
                                {(platform.commission / 100).toFixed(2)} */}
                                {platform.title}
                              </Typography>
                            }
                            // secondary={
                            //   <Box mt={1}>
                            //     <Typography fontSize={10}>
                            //       {`Followers Required: +${platform.min_followers}`}
                            //     </Typography>
                            //   </Box>
                            // }
                          />
                          <Box>
                            <Box align="right">
                              <Button
                                variant="contained"
                                size="small"
                                // onClick={() => {
                                //   getAuthUrl(platform.reference);
                                // }}
                                startIcon={<Icon>post_add</Icon>}
                              >
                                Post
                              </Button>
                            </Box>
                          </Box>
                        </ListItem>
                      ))}
                    </List>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </Box>
        ) : (
          <> </>
        )}
      </Box>
      <CheckoutFooter />
    </>
  );
}

export default SmmShare;
